const Adata = [
  {
    id: 1,
    title: "About Me",
    summary:
      "Full-Stack Web Developer with a passion to design beautiful and functional user experiences. Focused on writing clean,elegant and efficient code. Known as an innovative problem-solver and team player.",
  },
  {
    id: 2,

    title: "My Skills",
    summary:
      "Node.js, Express, JavaScript, jQuery, React.js, React Native, GIT, GitHub, MongoDB, MySQL, Firebase, HTML, CSS,Bootstrap, Media Queries, APIs, JSON, REST, AJAX, C# basic, DevOps,Microsoft Visual Studio.",
  },
  {
    id: 3,

    title: "What I do",
    summary:
      "Enjoys turning complex problems into simple, beautiful and intuitive responsive designs. When not coding, loves to paint, especially Buddha, trees and mountains.",
  },
  {
    id: 4,
    summary: " Email: prasamshari @gmail.com     or  Cell :   (206)-519-8877",
    title: "Contact Me",
    // summary: "prasamshari@gmail.com  hhhhhhhhhh cell: 206-519-8877 ",
    // title: "Contact Me",
    // summary: "prasamshari@gmail.com cell: 206-519-8877",
  },
];

export default Adata;
